<template>
	<div class="layout">
		<Layout :style="{minHeight: '100vh'}">
			<Header>
				<Menu name="11" mode="horizontal" theme="dark" active-name="1">
					<div class="layout-logo w-50">
			<h4 class="text-light ivu-menu-dark">数据综合网页</h4>
					</div>
					<div class="layout-nav">
						<Menu mode="horizontal" style="float: right;" theme="dark" active-name="1">
							<Submenu name="3">
								<template slot="title">
									<Icon type="ios-people" />
									<span>{{currentUser.userName}}</span>
								</template>
								<MenuItem name="3-1">
								<a @click="userDetail(currentUser.userId)" href="javascript:void(0)"
									:class="'w-100 h-100'">修改密码</a>
								</MenuItem>
								<MenuItem name="3-2">
								<a @click="logout" href="javascript:void(0)" :class="'w-100 h-100'">退出登录</a>
								</MenuItem>
							</Submenu>
						</Menu>
					</div>
				</Menu>
			</Header>
			<Layout>
				<Sider hide-trigger :class="'bg-light m-2'" v-show="currentUser.adm">
					<Menu active-name="1-2" theme="light" width="auto" :open-names="['1']">
						<Submenu v-for="(item, key) in current.admin" :id="key" :name="item.permissionId"
							v-show="currentUser.adm">
							<template slot="title">
								<Icon type="ios-navigate"></Icon>
								{{item.name}}
							</template>
							<MenuItem v-for="(subItem, index) in current.active" :name="subItem.name"
								:to="subItem.path">
							<a>{{subItem.name}}</a>
							</MenuItem>
						</Submenu>
					</Menu>
				</Sider>
				<Layout>
					<Content :class="'m-2'">
						<router-tab :class="''" />
					</Content>
				</Layout>
			</Layout>
		</Layout>
	</div>
</template>

<script>
	import store from "../../common/store.js"
	export default {
		data() {
			return {
				currentUser: {},
				current: {
					admin: [{
						Key: 1,
						permissionId: 2,
						name: "管理员操作"
					}],
					active: [{
							Key: 1,
							path: "/user",
							name: "用户管理"
						},
						{
							Key: 2,
							path: "/controlData",
							name: "控制数据管理"
						},
						{
							Key: 3,
							path: "/statuData",
							name: "状态数据管理"
						},
						{
							Key: 4,
							path: "/deviceType",
							name: "设备型号管理"
						},
					]
				}

			};
		},
		methods: {
			logout: () => {
				store.commit("loginOut");
			},
			userDetail: function(userId) {
				this.$router.push({
					name: "user_detail",
					params: {
						userId
					}
				});
			},
		},
		mounted: function() {
			this.currentUser = JSON.parse(sessionStorage.getItem("CURRENT_USER"))
		},
		computed: {
			// 	current: function() {
			// 		return store.state.currentUser;
			// 	}
		}
	}
</script>

<style scoped>
	.layout {
		position: relative;
		border-radius: 4px;
		overflow: hidden;
	}

	.layout-logo {
		width: 100px;
		height: 30px;
		background: #5b6270;
		border-radius: 3px;
		float: left;
		position: relative;
		top: 15px;
		left: 20px;
	}

	.layout-nav {
		width: calc(100% - 100px);
		margin: 0 auto;
		margin-right: 20px;
	}
</style>
